import { guardString } from "@msuite/utils/strings";
import clsx from "clsx";
import { LinkIcon } from "../icons/link-icon";

/** Props Interface */
interface LinksProps {
	children: React.ReactNode;
	href: string | null;
	className?: string;
	icon?: React.ReactNode;
	onClick?: () => void;
	isExternal?: boolean;
}

export const Link: React.FC<LinksProps> = ({
	children,
	href,
	className,
	icon,
	onClick,
	isExternal,
}) => {
	const hasIcon = !!icon || !!isExternal;

	if (!href) return <p>{guardString(null)}</p>;

	/** Render */
	return (
		<a
			href={href}
			onClick={
				onClick
					? (e) => {
							e.preventDefault();
							onClick?.();
						}
					: undefined
			}
			target="_blank"
			className={clsx("link", className)}
			rel="noopener"
		>
			<span>{children || href}</span>
			{hasIcon ? (
				<span className="link-icon">
					<LinkIcon
						isExternal={isExternal}
						icon={icon}
					/>
				</span>
			) : null}
		</a>
	);
};
